module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-heading bg-color-skin"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 align-center"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.nameCodapp) + " ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.linkDisp),
      expression: "linkDisp"
    }],
    staticClass: "col-xs-2 align-right",
    attrs: {
      "title": _vm.tooltip
    },
    on: {
      "click": function($event) {
        _vm.redirectToLeaveReq()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle ",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-16430594!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/calendar_header.vue
// module id = 3590
// module chunks = 1